import React from "react";
import { LegalLayout } from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz." eyebrow="Datenschutzerklärung">
      <h2 className="legal-h2">Präambel</h2>
      <p>
        Mit der folgenden Datenschutzerklärung möchten wir Sie darüber aufklären, welche Arten Ihrer
        personenbezogenen Daten (nachfolgend auch kurz als „Daten" bezeichnet) wir zu welchen Zwecken
        und in welchem Umfang verarbeiten. Die Datenschutzerklärung gilt für alle von uns durchgeführten
        Verarbeitungen personenbezogener Daten, sowohl im Rahmen der Erbringung unserer Leistungen als
        auch insbesondere auf unseren Webseiten, in mobilen Applikationen sowie innerhalb externer
        Onlinepräsenzen, wie z.B. unserer Social-Media-Profile.
      </p>
      <p>Stand: 30. Juni 2024</p>

      <h2 className="legal-h2">Verantwortlicher</h2>
      <div>
        <p>monoton. Veranstaltungstechnik</p>
        <p>Marvin Wiegand</p>
        <p>Tobias Hauser</p>
        <p>Justus Scheinkönig</p>
        <p>Jakob Hillebrand</p>
        <p>Blütenstraße 6</p>
        <p>90480 Nürnberg</p>
        <p>Deutschland</p>
        <p className="mt-2">
          E-Mail:{" "}
          <a href="mailto:hello@monoton.events" className="text-amber hover:underline">
            hello@monoton.events
          </a>
        </p>
        <p>
          Telefon:{" "}
          <a href="tel:+491728117625" className="text-amber hover:underline">
            +49 172 811 7625
          </a>
        </p>
      </div>

      <h2 className="legal-h2">Übersicht der Verarbeitungen</h2>
      <p>
        Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer
        Verarbeitung zusammen und verweist auf die betroffenen Personen.
      </p>

      <h3 className="font-display font-semibold text-offwhite mt-4 mb-2">Arten der verarbeiteten Daten</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>Bestandsdaten</li>
        <li>Zahlungsdaten</li>
        <li>Kontaktdaten</li>
        <li>Inhaltsdaten</li>
        <li>Vertragsdaten</li>
        <li>Nutzungsdaten</li>
        <li>Meta-, Kommunikations- und Verfahrensdaten</li>
      </ul>

      <h3 className="font-display font-semibold text-offwhite mt-4 mb-2">Kategorien betroffener Personen</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>Leistungsempfänger und Auftraggeber</li>
        <li>Interessenten</li>
        <li>Kommunikationspartner</li>
        <li>Nutzer</li>
        <li>Geschäfts- und Vertragspartner</li>
      </ul>

      <h3 className="font-display font-semibold text-offwhite mt-4 mb-2">Zwecke der Verarbeitung</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>Erbringung vertraglicher Leistungen und Erfüllung vertraglicher Pflichten</li>
        <li>Kommunikation</li>
        <li>Direktmarketing</li>
        <li>Büro- und Organisationsverfahren</li>
        <li>Öffentlichkeitsarbeit</li>
        <li>Geschäftsprozesse und betriebswirtschaftliche Verfahren</li>
      </ul>

      <h2 className="legal-h2">Maßgebliche Rechtsgrundlagen</h2>
      <p>
        Im Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir
        personenbezogene Daten verarbeiten. Bitte nehmen Sie zur Kenntnis, dass neben den Regelungen
        der DSGVO nationale Datenschutzvorgaben in Ihrem bzw. unserem Wohn- oder Sitzland gelten
        können. Sollten ferner im Einzelfall speziellere Rechtsgrundlagen maßgeblich sein, teilen wir
        Ihnen diese in der Datenschutzerklärung mit.
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <strong className="text-offwhite">Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO)</strong> –
          Die betroffene Person hat ihre Einwilligung in die Verarbeitung der sie betreffenden
          personenbezogenen Daten für einen spezifischen Zweck oder mehrere bestimmte Zwecke gegeben.
        </li>
        <li>
          <strong className="text-offwhite">Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</strong> –
          Die Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene
          Person ist, oder zur Durchführung vorvertraglicher Maßnahmen erforderlich.
        </li>
        <li>
          <strong className="text-offwhite">Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</strong> –
          Die Verarbeitung ist zur Wahrung der berechtigten Interessen des Verantwortlichen oder eines
          Dritten erforderlich, sofern nicht die Interessen oder Grundrechte der betroffenen Person überwiegen.
        </li>
      </ul>

      <h2 className="legal-h2">Allgemeine Informationen zur Datenspeicherung und Löschung</h2>
      <p>
        Wir löschen personenbezogene Daten, die wir verarbeiten, gemäß den gesetzlichen Vorgaben,
        sobald die zugrundeliegenden Einwilligungen widerrufen werden oder keine weiteren rechtlichen
        Grundlagen für die Verarbeitung bestehen. Dies betrifft Fälle, in denen der ursprüngliche
        Verarbeitungszweck entfällt oder die Daten nicht mehr benötigt werden. Ausnahmen von dieser
        Regelung bestehen, wenn gesetzliche Pflichten oder besondere Interessen eine längere
        Aufbewahrung oder Archivierung der Daten erfordern.
      </p>
      <p>
        Insbesondere müssen Daten, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden
        müssen oder deren Aufbewahrung notwendig ist zur Rechtsverfolgung oder zum Schutz der Rechte
        anderer natürlicher oder juristischer Personen, entsprechend archiviert werden. Unsere
        Datenschutzhinweise enthalten zusätzliche Informationen zur Aufbewahrung und Löschung von
        Daten, die speziell für bestimmte Verarbeitungsprozesse gelten.
      </p>
      <p>
        Bei geschäftlichen Daten sind die gesetzlichen Aufbewahrungsfristen zu beachten:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li>10 Jahre für Buchungsbelege und Jahresabschlüsse</li>
        <li>6 Jahre für Handelsbriefe und sonstige Geschäftsunterlagen</li>
        <li>3 Jahre für Ansprüche aus Gewährleistung und Produkthaftung</li>
      </ul>

      <h2 className="legal-h2">Geschäftliche Leistungen</h2>
      <p>
        Wir verarbeiten Daten unserer Vertrags- und Geschäftspartner, z.B. Kunden und Interessenten
        (zusammenfassend bezeichnet als „Vertragspartner") im Rahmen von vertraglichen und
        vergleichbaren Rechtsverhältnissen sowie damit verbundenen Maßnahmen und im Rahmen der
        Kommunikation mit den Vertragspartnern (oder vorvertraglich), z.B. um Anfragen zu beantworten.
      </p>
      <p>
        Die verarbeiteten Daten umfassen Namen, Kontaktdaten, Angaben zu Veranstaltungen sowie
        Zahlungs- und Vertragsdaten. Die Verarbeitung erfolgt zur Erfüllung unserer vertraglichen
        Leistungen, Sicherung unserer Rechte und zur Kommunikation mit den Vertragspartnern.
        Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b und lit. f DSGVO.
      </p>

      <h2 className="legal-h2">Kontakt- und Anfrageverwaltung</h2>
      <p>
        Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer
        Medien) sowie im Rahmen bestehender Nutzer- und Geschäftsbeziehungen werden die Angaben der
        anfragenden Personen verarbeitet soweit dies zur Beantwortung der Kontaktanfragen und etwaiger
        angefragter Maßnahmen erforderlich ist.
      </p>
      <p>
        Die Beantwortung der Kontaktanfragen sowie die Verwaltung von Kontakt- und Anfragedaten im
        Rahmen von vertraglichen oder vorvertraglichen Beziehungen erfolgt zur Erfüllung unserer
        vertraglichen Pflichten oder zur Beantwortung von (vor)vertraglichen Anfragen und im Übrigen
        auf Grundlage der berechtigten Interessen an der Beantwortung der Anfragen und Pflege von
        Nutzer- bzw. Geschäftsbeziehungen.
      </p>

      <h2 className="legal-h2">Präsenzen in sozialen Netzwerken</h2>
      <p>
        Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und verarbeiten in diesem Rahmen
        Daten der Nutzer, um mit den dort aktiven Nutzern zu kommunizieren oder um Informationen über
        uns anzubieten.
      </p>
      <p>
        Wir weisen darauf hin, dass dabei Daten der Nutzer außerhalb des Raumes der Europäischen Union
        verarbeitet werden können. Hierdurch können sich für die Nutzer Risiken ergeben, weil so z.B.
        die Durchsetzung der Rechte der Nutzer erschwert werden könnte.
      </p>
      <p>
        Wir unterhalten ein Profil bei Instagram. Anbieter: Meta Platforms Ireland Limited, 4 Grand
        Canal Square, Grand Canal Harbour, Dublin 2, Irland. Rechtsgrundlage: Berechtigte Interessen
        (Art. 6 Abs. 1 S. 1 lit. f DSGVO). Datentransfer in Drittländer auf Basis des EU-US Data
        Privacy Frameworks.
      </p>

      <h2 className="legal-h2">Rechte der betroffenen Personen</h2>
      <p>Ihnen stehen als Betroffene nach der DSGVO verschiedene Rechte zu:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <strong className="text-offwhite">Widerspruchsrecht:</strong> Sie haben das Recht, aus Gründen,
          die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie
          betreffender personenbezogener Daten Widerspruch einzulegen.
        </li>
        <li>
          <strong className="text-offwhite">Widerrufsrecht:</strong> Sie haben das Recht, erteilte
          Einwilligungen jederzeit zu widerrufen.
        </li>
        <li>
          <strong className="text-offwhite">Auskunftsrecht:</strong> Sie haben das Recht, eine
          Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet werden, und Auskunft über
          diese Daten sowie weitere Informationen zu erhalten.
        </li>
        <li>
          <strong className="text-offwhite">Berichtigungsrecht:</strong> Sie haben das Recht, die
          Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden
          unrichtigen Daten zu verlangen.
        </li>
        <li>
          <strong className="text-offwhite">Löschungsrecht:</strong> Sie haben das Recht zu verlangen,
          dass Sie betreffende Daten unverzüglich gelöscht werden.
        </li>
        <li>
          <strong className="text-offwhite">Datenübertragbarkeit:</strong> Sie haben das Recht, die Sie
          betreffenden Daten in einem strukturierten, gängigen, maschinenlesbaren Format zu erhalten
          oder deren Übertragung an einen anderen Verantwortlichen zu fordern.
        </li>
        <li>
          <strong className="text-offwhite">Beschwerderecht:</strong> Sie haben unbeschadet eines
          anderweitigen Rechtsbehelfs das Recht auf Beschwerde bei einer Aufsichtsbehörde.
        </li>
      </ul>
    </LegalLayout>
  );
}
